import { CalendarSelectionView } from "../components";
import { PassengerSelectionView } from "../components";
import { FlightOriginSelection } from "../components/flights/origin-selection";
import { FlightDestinationSelection } from "../components/flights/destination-selection";
import { EditFlightSelection } from "../components/flights/edit-flight-selection";
import { GuestSelectionView } from "../components/hotels/guest-selection";
import { HotelsDestinationSelection } from "../components/hotels/destination-selection";
import { HotelsCalendarSelection } from "../components/hotels/calendar-selection";
import { EditHotelSelection } from "../components/hotels/edit-hotel-selection";
import { CarPickupLocationSelection, CarDropoffLocationSelection, CarDatesSelection, CarPickupTimeSelection, CarDropoffTimeSelection, EditCarSelection } from "../components/cars";
export const MobileRegistry = {
  components: {
    PassengerSelection: PassengerSelectionView,
    CalendarSelection: CalendarSelectionView,
    FlightOriginSelection: FlightOriginSelection,
    FlightDestinationSelection: FlightDestinationSelection,
    EditFlightSelection: EditFlightSelection,
    GuestSelection: GuestSelectionView,
    HotelsDestinationSelection: HotelsDestinationSelection,
    HotelsCalendarSelection: HotelsCalendarSelection,
    EditHotelSelection: EditHotelSelection,
    CarPickupLocationSelection: CarPickupLocationSelection,
    CarDropoffLocationSelection: CarDropoffLocationSelection,
    CarDatesSelection: CarDatesSelection,
    CarPickupTimeSelection: CarPickupTimeSelection,
    CarDropoffTimeSelection: CarDropoffTimeSelection,
    EditCarSelection: EditCarSelection
  }
};